import { api } from '@orisini/ui/lib/api'

export interface SlotDto {
  id: string
  dow: number
  minuteOfDay: number
  enabled: boolean
  boardId: string | null
  label: string | null
}

export interface SlotsResponse {
  slots: SlotDto[]
  timezone: string
}

export interface SlotPreview {
  timezone: string
  instants: Array<{ at: number; slotId: string; local: string }>
}

export const slotsApi = {
  list: (accountId: string) => api.get<SlotsResponse>(`/accounts/${accountId}/slots`),
  bulk: (accountId: string, slots: Array<Pick<SlotDto, 'dow' | 'minuteOfDay'> & Partial<SlotDto>>) =>
    api.post<SlotsResponse>(`/accounts/${accountId}/slots/bulk`, { slots }),
  preview: (accountId: string) => api.get<SlotPreview>(`/accounts/${accountId}/slots/preview`),
}

export const DOW_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const

export function minuteToHHMM(minute: number): string {
  const h = Math.floor(minute / 60)
  const m = minute % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

export function hhmmToMinute(value: string): number | null {
  const m = /^(\d{1,2}):(\d{2})$/.exec(value.trim())
  if (!m) return null
  const hour = Number(m[1])
  const minute = Number(m[2])
  if (hour > 23 || minute > 59) return null
  return hour * 60 + minute
}
